import React from "react";
import PropTypes from "prop-types";
import R from "ramda";
import { connect } from "react-redux";
import { envelopeType } from "custom-prop-types";
import { UploadInlineTabs } from "components/upload-documents/upload-inline-tabs";
import { ManageEnvelopes } from "components/manage-envelopes/manage-envelopes";
import {
  requestEnvelopeAction,
  setCoversheetAction,
  setRequestEnvelopeVisibilityAction,
  setSendEnvelopeVisibilityAction
} from "actions/envelopes-actions";
import { trackPageAction } from "actions/shared/tracking-actions";
import { addEnvelopeToFilterAction } from "actions/document-filters-actions";
import { setFlashMessageAction } from "actions/app-actions";
import { mapEnvelopeUploadedKey } from "containers/manage-envelopes-container";

const AwaitingMailinPage = (props) => {
  const envelopes = R.filter(
    (envelope) => envelope.status !== "uploaded" || envelope.status !== "returned",
    props.envelopes
  );
  return (
    <div>
      <UploadInlineTabs accountSlug={ props.slug } currentPage="awaiting-mailin" />
      <ManageEnvelopes
        { ...props }
        envelopes={ mapEnvelopeUploadedKey(envelopes) }
        isAwaitingMailin
        isLinkable={ false }
        title="Awaiting Mail In"
      />
    </div>
  );
};

AwaitingMailinPage.defaultProps = {
  envelopes: []
};

AwaitingMailinPage.propTypes = {
  envelopes: PropTypes.arrayOf(envelopeType),
  slug: PropTypes.string.isRequired
};

const mapStateToProps = (state) => ({
  accountId: state.app.selectedAccount.id,
  coversheetUrl: state.envelopes.coversheetUrl,
  envelopes: state.envelopes.envelopes,
  isLoading: state.envelopes.isLoading,
  isRequestEnvelopeVisible: state.envelopes.isRequestEnvelopeVisible,
  isSendEnvelopeVisible: state.envelopes.isSendEnvelopeVisible,
  slug: state.app.selectedAccount.slug
});

const mapDispatchToProps = (dispatch) => ({
  init: (accountId) => dispatch(setCoversheetAction(accountId)),
  trackPage: () => dispatch(trackPageAction("Awaiting mail in page")),
  onAddEnvelope: (code) => dispatch(addEnvelopeToFilterAction(code)),
  onHideRequestEnvelope: () => dispatch(setRequestEnvelopeVisibilityAction(false)),
  onHideSendEnvelope: () => dispatch(setSendEnvelopeVisibilityAction(false)),
  onRequestEnvelope: (accountId) => dispatch(requestEnvelopeAction(accountId)),
  onSetFlashMessage: (message) => dispatch(setFlashMessageAction(message)),
  onShowRequestEnvelope: () => dispatch(setRequestEnvelopeVisibilityAction(true)),
  onShowSendEnvelope: () => dispatch(setSendEnvelopeVisibilityAction(true))
});


export const AwaitingMailinContainer = connect(mapStateToProps, mapDispatchToProps)(AwaitingMailinPage);



// WEBPACK FOOTER //
// ./src/js/containers/awaiting-mailin-container.jsx